<template>
  <div class="goods-inventory">
    <div class="title">{{ $t('product.num') }}</div>
    <div class="num-wrapper">
      <el-input-number
        size="small"
        class="input"
        v-model="num"
        :min="1"
        :max="max"
        :step="1"
        @change="handleChange"
      />
      <div class="inventory" v-if="currSku.quantity">{{ $t('product.inventory') }}: {{ max }}</div>
    </div>

    <!-- <span class="inventory"
      >{{ $t('product.inventory') }}: {{ max || '--' }}</span
    > -->
  </div>
  <div :class="{ 'min-num': true, 'min-num-other': isFloat }">
    {{ $t('product.nimNumTips', { num: $props.goods.startQuantity || '--' }) }}
  </div>
  <div v-if="num > 9" class="tips">
    {{ $t('order.goodNumTip') }}
  </div>
</template>

<script setup>
import { computed, defineEmits, defineProps } from 'vue'
const $props = defineProps({
  isFloat: {
    type: Boolean,
    default: false,
  },
  goods: {
    type: Object,
    default: () => ({}),
  },
  value: {
    type: Number,
    default: 1,
  },
  currSku: {
    type: Object,
    default: () => ({}),
  },
})
const $emit = defineEmits(['update:value', 'change'])
const max = computed(() => $props.currSku?.quantity || $props.value)

const num = computed({
  get() {
    return $props.value
  },
  set(value) {
    $emit('update:value', value)
  },
})

const handleChange = () => {
  $emit('change')
}
</script>

<style lang="scss" scoped>
.goods-inventory {
  line-height: 32px;
  margin-top: 14px;
  margin-bottom: 4px;

  .title {
    font-family: Montserrat;
    font-size: 18px;
    font-weight: bold;
    line-height: normal;
    text-transform: capitalize;
    letter-spacing: 0em;
    color: var(--black-color-9);
    margin-bottom: 17px;
  }

  .num-wrapper {
    display: flex;
    align-items: center;

    .inventory {
      font-size: 14px;
      margin-left: 19px;
    }
  }

  .inventory {
    color: var(--black-color-3d);
    margin-left: 14px;
    font-family: Montserrat;
    font-size: 16px;
    line-height: normal;
    text-transform: capitalize;
    letter-spacing: 0em;
    color: var(--black-color-9);
  }

  // .ipt-class {
  //   background: var(--white-color-1);
  //   height: 32px;
  //   ::v-deep(.el-input__wrapper) {
  //     height: 32px;
  //     background: var(--white-color-1);
  //     border: 1px solid var(--border-da);
  //   }
  //   ::v-deep(.el-input-number__decrease),
  //   ::v-deep(.el-input-number__increase) {
  //     width: 32px;
  //     border: 1px solid var(--border-da);
  //   }
  //   ::v-deep(.el-input-number__decrease) {
  //     border-radius: 8px 0 0 8px;
  //   }
  //   ::v-deep(.el-input-number__increase) {
  //     border-radius: 0px 8px 8px 0px;
  //   }
  // }

  .input {
    width: 182px;
    height: 32px;
    // background: var(--white-color-1);
    border-radius: 8px;

    ::v-deep(.el-input__wrapper) {
      height: 32px;
    }

    ::v-deep(.el-input-number__decrease),
    ::v-deep(.el-input-number__increase) {
      font-family: Montserrat;
      font-size: 12px;
      font-weight: normal;
      line-height: 27px;
      text-transform: uppercase;
      letter-spacing: 0em;
      // color: var(--black-color-9);
      // background: #f6f7fa;
      width: 32px;
    }

    ::v-deep(.el-input-number__decrease) {
      border-radius: 8px 0 0 8px;
    }

    ::v-deep(.el-input__inner) {
      font-family: Montserrat;
      font-size: 14px;
      font-weight: normal;
      line-height: 27px;
      text-transform: uppercase;
      letter-spacing: 0em;
      // color: var(--black-color-9);
      // background-color: var(--white-color-1);
      height: 100%;
    }
  }
}

.min-num {
  font-family: Montserrat;
  font-size: 14px;
  font-weight: normal;
  line-height: 27px;
  text-transform: uppercase;
  letter-spacing: 0em;
  color: var(--black-color-6);
  margin-top: 8px;
  // border-bottom: 1px solid var(--line-light-gray-color);
  margin-bottom: 14px;
}

.min-num-other {
  border-bottom: none;
}

.tips {
  color: var(--black-color-6);
  font-size: 14px;
  margin-bottom: 14px;
  line-height: normal;
}
</style>
